import { Col, FloatingLabel, FormCheck, FormControl, Row } from "react-bootstrap"
import HoverCard from "../../../shared/HoverCard"
import { SlEnergy } from "react-icons/sl"
import { TbFlame } from "react-icons/tb"
import { MdOutlineSolarPower } from "react-icons/md"
import Validator from "../../../../services/Validator"
import { useAuthState } from "../../../../context/AuthContext"
import EnergoTooltip from "../../../shared/EnergoTooltip"

const AnlageDataMask = ({data, setData, formError, setFormError}) => {

    const { tooltips, tooltipsTrigger } = useAuthState();
    const VALIDATOR = new Validator();

    const energyFormHandler = (newVal) => {
        setFormError({});
        if (data.energyForm) {
            if (data.energyForm === newVal) setData(prev => ({...prev, energyForm: newVal}));
            else setData(prev => ({...prev, energyForm: newVal}));
        } else {
            setData(prev => ({...prev, energyForm: newVal}));
        }
    }

    const x_zaehlernummer_01Handler = (e) => {
        const value = e.target.value; 
        const filtered = value.replace(/[^a-zA-Z0-9/]/g, "");
        setData(prev => ({
            ...prev, 
            x_zaehlernummer_01: filtered
        }));
        setFormError({});
    }

    const x_zaehlernummer_02Handler = (e) => {
        const value = e.target.value; 
        const filtered = value.replace(/[^a-zA-Z0-9/]/g, "");
        setData(prev => ({
            ...prev, 
            x_zaehlernummer_02: filtered
        }));
        setFormError({});
    }

    const zaehlpunktHandler = (e, whichZp) => {
        setFormError({});
        const inputValue = e.target.value;

        // replace any characters that aren't digit or letter
        const formatedValue = inputValue.replace(/[^a-zA-Z-0-9]/g, '').toUpperCase();

        const prefix = formatedValue.substring(0, 2);

        const reset = formatedValue.substring(2);

        // group characters in 5 block 
        const groupReset = reset.replace(/(.{5})(?=.)/g, "$1 ");

        const formatedGroup = prefix + (groupReset ? " " + groupReset : "");

        if (whichZp === 1) {
            return setData(prev => ({
                ...prev,
                x_zaehlpunktnummer_01: formatedGroup
            }));
        } 
        if (whichZp === 2) {
            return setData(prev => ({
                ...prev,
                x_zaehlpunktnummer_02: formatedGroup
            }));
        }
    }

    return (
        <>
            <Row style={formError.energyForm && {border: "1px solid red"}} className="py-2">
                <p className="text-energo"><b>Energieform</b></p>
                <Col xs="4">
                    <HoverCard
                        icon={<SlEnergy size={35} />}
                        desc="Stromanlage"
                        color="energo"
                        isSelected={data.energyForm === "Strom"}
                        otherSelected={data.energyForm !== "Strom" && data.energyForm !== ""}
                        clickHandler={() => energyFormHandler("Strom")}
                    />
                </Col>
                <Col xs="4">
                    <HoverCard
                        icon={<TbFlame size={35} />}
                        desc="Gasanlage"
                        color="info"
                        isSelected={data.energyForm === "Gas"}
                        otherSelected={data.energyForm !== "Gas" && data.energyForm !== ""}
                        clickHandler={() => energyFormHandler("Gas")}
                    />
                </Col>
                <Col xs="4">
                    <HoverCard
                        icon={<MdOutlineSolarPower size={35} />}
                        desc="Strom-Einspeisung"
                        color="warning"
                        isSelected={data.energyForm === "Strom-Einspeisung"}
                        otherSelected={data.energyForm !== "Strom-Einspeisung" && data.energyForm !== ""}
                        clickHandler={() => energyFormHandler("Strom-Einspeisung")}
                    />
                </Col>
            </Row>
            <Row className="mt-4 ps-1">
                <Col xs="12" md="6" xl="3" className="d-flex">
                    <FormCheck 
                        className="me-2"
                        type="checkbox" 
                        label="Smartmeter" 
                        checked={data.x_is_smartmeter_01} 
                        onChange={e => {setData(prev => ({...prev, x_is_smartmeter_01: e.target.checked, x_is_smartmeter_02: e.target.checked})); setFormError({})}}
                    />
                    <EnergoTooltip tKey="102" position="right" />
                </Col>
                <Col xs="12" md="6" xl="3" className="d-flex">
                    <FormCheck
                        className="me-2"
                        type="checkbox"
                        label="Zweiter Zähler vorhanden"
                        checked={data.secondZaehler}
                        onChange={e => {setData(prev => ({...prev, secondZaehler: e.target.checked})); setFormError({})}}
                    />
                    <EnergoTooltip tKey="103" position="right" />
                </Col>
            </Row>
            <Row className="mt-4 align-items-center">
                <Col xs="11" md="5" xl="5">
                    <FloatingLabel label="Zählernummer">
                        <FormControl
                            placeholder="Zählernummer"
                            value={data.x_zaehlernummer_01}
                            onChange={e => x_zaehlernummer_01Handler(e)}
                            isValid={data.x_zaehlernummer_01 && data.x_zaehlernummer_01.length > 5}
                            isInvalid={formError.x_zaehlernummer_01}
                        />
                    </FloatingLabel>
                </Col>
                <Col xs="1" md="1" xl="1">
                    <EnergoTooltip tKey="104" position="right" />
                </Col>

                <Col xs="12" md="5" xl="5" hidden={!data.secondZaehler || data.secondZaehler === false}>
                    <FloatingLabel label="Zweite Zählernummer">
                        <FormControl
                            placeholder="Zweite Zählernummer"
                            value={data.x_zaehlernummer_02}
                            onChange={e => x_zaehlernummer_02Handler(e)}
                            isValid={data.x_zaehlernummer_02 && data.x_zaehlernummer_02.length > 5}
                            isInvalid={formError.x_zaehlernummer_02}
                        />
                    </FloatingLabel>
                </Col>
            </Row>
            <Row className="mt-4">
                <Col xs="12" md="12" xl="6">
                    <FloatingLabel label={`Zählpunktnummer ${data.x_zaehlernummer_01 !== "" ? `von ${data.x_zaehlernummer_01}`:''} (falls vorhanden)`}>
                        <FormControl
                            placeholder="Zählpunktnummer"
                            value={data.x_zaehlpunktnummer_01}
                            onChange={e => zaehlpunktHandler(e, 1)}
                            isValid={VALIDATOR.isFormatedZaehlpunknummerValid(data.x_zaehlpunktnummer_01)}
                            isInvalid={formError.x_zaehlpunktnummer_01}
                        />
                    </FloatingLabel>
                </Col>
                <Col xs="12" md="12" xl="6" hidden={!data.secondZaehler || data.secondZaehler === false}>
                    <FloatingLabel label={`Zählpunktnummer ${data.x_zaehlernummer_02 !== "" ? `von ${data.x_zaehlernummer_02}`:''} (falls vorhanden)`}>
                        <FormControl
                            placeholder="Zweite Zählpunktnummer"
                            value={data.x_zaehlpunktnummer_02}
                            onChange={e => zaehlpunktHandler(e, 2)}
                            isValid={VALIDATOR.isFormatedZaehlpunknummerValid(data.x_zaehlpunktnummer_02)}
                            isInvalid={formError.x_zaehlpunktnummer_02}
                        />
                    </FloatingLabel>
                </Col>
            </Row>
            <Row className="mt-4 align-items-center">
                <Col xs="11" md="11" xl="8">
                    <FloatingLabel label="Zähler-Standort">
                        <FormControl
                            placeholder="Zähler-Standort"
                            value={data.zaehlerLocation}
                            onChange={e => {setData(prev => ({...prev, zaehlerLocation: e.target.value})); setFormError({})}}
                            isValid={data.zaehlerLocation && data.zaehlerLocation !== ""}
                        />
                    </FloatingLabel>
                </Col>
                <Col xs="1" md="1" xl="1">
                    <EnergoTooltip tKey="105" position="right" />
                </Col>
            </Row>
        </>
    )
}
export default AnlageDataMask;